<template>
	<div class="st-main-content">
		<div class="account-search-box">
			<div class="query-setting-box">
				<div class="query-setting-box-left">
					<div class="order-query-form-box">
						<label for="start-date">用户id：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.roleId"
								name="start-date"></span>
					</div>
					<div class="order-query-form-box">
						<label for="start-date">姓名：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.username"
								name="start-date"></span>
					</div>
					<div class="order-query-form-box">
						<label for="start-date">角色名称：</label>
						<span class="order-query-form-input"><input type="text" v-model="orderForm.loginAccount"
								name="start-date"></span>
					</div>
					<!-- <div class="order-query-form-box">
						<label for="start-date">公司名称：</label>
						<span class="order-query-form-input"><input type="text"  v-model="orderForm.companyName" name="start-date"></span>
					</div> -->
				</div>
				<div class="order-query-form-box-right">
					<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
				</div>
			</div>
		</div>

		<div class="data-table-box">
			<common-table
				ref="CommonTableRef"
				:tableColumns="tableColumns"
				:data="dataList"
				:showPage="togglePage"
				:loading="loading"
				
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange"
				@currentChange="currentChange"
				@sizeChange="sizeChange"
			>
				<template slot="contactSubject" slot-scope="scope">
                    <span>{{scope.row.contactSubject}}</span>
                </template>

				<template slot="state" slot-scope="scope">
					<span>{{scope.row.state?'是':'否'}}</span>
				</template>
			</common-table>
		</div>
		<st-dialog :title="dialogTitle" :toggleStDialog="toggleStDialog" @closeDialog="closeDialogForm" 
			@saveDialog="saveDialogForm">
			<div class="st-dialog-content" style="width: 720px;">
				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">用户名：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.username"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">手机号：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.phone"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">密码录入：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.password"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">登录账号：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.loginAccount"></div>
					</li>
				</ul>

				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title">加盟公司：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.contactSubject"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">加盟公司手机号：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="editData.contactPhone"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">账户类型：</div>
						<div class="st-dialog-item-input">
							<el-select v-model="editData.genre" placeholder="请选择" size="small">
								<el-option v-for="item in options3" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</li>
					<li style="width: 200px;">
						<div class="st-dialog-item-title">角色类型：</div>
						<div class="st-dialog-item-input">
							<el-select v-model="editData.roleId" 
							placeholder="请选择" 
							multiple
    						collapse-tags
							size="small">
								<el-option v-for="item in roleTypeList" 
								:key="item.id" 
								:label="item.name"
								:value="item.id">
								</el-option>
							</el-select>
						</div>
					</li>
				</ul>

				<ul class="st-dialog-form clearfix">
						<li>
							<div class="st-dialog-item-title">付款方式：</div>
							<div class="st-dialog-item-input">
								<el-select v-model="editData.waybillPaymentType" placeholder="请选择" size="small">
									<el-option v-for="item in paymentTypeList" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</li>
					</ul>

				<ul class="st-dialog-form clearfix">
					<li style="width: 250px;">
						<div class="st-dialog-item-title">省/市/区</div>
						<div class="st-dialog-item-input">
							<el-cascader class="ssq" size="small" :options="options" v-model="selectedOptions"
								@change="handleChange"
							>
							</el-cascader>
						</div>
					</li>
					<li style="width: 250px;">
						<div class="st-dialog-item-title">详细地址：</div>
						<div class="st-dialog-item-input">
							<!-- <input type="text" v-model="editData.shortAddress"> -->
							<el-select class="ssq" v-model="editData.shortAddress" filterable remote :remote-method="getNearAddress"
							:loading="loading" placeholder="请输入详细地址" size="small" @change="shortAddressChange">
								<el-option
									v-for="item in nearAddressArr"
									:key="item.title"
									:label="item.title"
									:value="{value:item.title,location:item.location}">
								</el-option>
							</el-select>
						</div>
					</li>
				</ul>
			</div>
		</st-dialog>
	</div>
</template>
<script>
	import stDialog from '../../components/StDialog'
	import { cityJson, CodeToText } from '@/assets/common/city.js'
	import { geoplace2, geoplace } from '@/utils/mapUtil.js'
	
	export default {
		name: 'AccountManage',
		props: [],
		components: { stDialog },
		data() {
			return {
				tableColumns:[
					{
						type: 'selection',
						fixed: 'left',
					},{
						key: '',
						title: '操作',
						operate:true,
						setBtns:(row,index)=>{
							return [
								{
									label:'编辑',
									handler: (row,index) => this.editUser(row)
								}
							]
						}
					},{
						key: 'loginAccount',
						title: '登录账号',
					},{
						key: 'phone',
						title: '手机号',
					},{
						key: 'username',
						title: '用户名',
					},{
						key: 'roleName',
						title: '角色名称',
					},{
						slotName: 'state',
						slot:true,
						title: '是否有效',
					},{
						slotName:'contactSubject',
						slot:true,
						title: '公司名称',
					},{
						key: 'contactSubject',
						title: '联系人',
					},{
						key: 'provinceName',
						title: '省',
					},{
						key: 'cityName',
						title: '市',
					},{
						key: 'areaName',
						title: '区',
					},{
						key: 'shortAddress',
						title: '详细地址',
					}
				],
				loading: false,
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
					layout: "total, sizes",
				},
				bottomHandleArr: [
					{
						label: '删除账号',
						handler: () => this.deleteUser()
					},{
						label: '新增账号',
						type: 'success',
						handler: () => this.addUser()
					},
				],


				nearAddressArr: [],
				loading: false,
				options: cityJson,
				selectedOptions: [],
				options2: [{
					value: '1',
					label: '是'
				}, {
					value: '2',
					label: '否'
				}],
				options3: [{
					value: 'SYSTEM',
					label: '系统用户'
				}, {
					value: 'FRANCHISE',
					label: '加盟公司'
				}],
				paymentTypeList: [{
					value: 0,
					label: '寄付'
				}, {
					value: 1,
					label: '到付'
				}, {
					value: 2,
					label: '月结'
				}],
				roleTypeList: [
					{
						name: '超级管理员',
						id: 0
					},
					{
						name: '加盟公司',
						id: 1
					},
					{
						name: '管理员',
						id: 2
					},
				],
				value: '',
				value2: '',
				userId: null,
				currentEditData:{},
				editData: {
					genre: '系统用户'
				},
				normalCheck: {
					username: '用户名必填',
					phone: '手机号必填',
					genre: '账号类型必填',
					password: '登录密码必填',
					username: '用户名必填',
					loginAccount: '登录账号必填'
				},
				franshiseCheck: {
					provinceName: '省市区必填',
					shortAddress: '详细地址必填',
					contactPhone: '联系方式必填',
					contactSubject: '联系人或公司必填'
				},
				dataList: [],
				selectedList: [],
				orderForm: {
					loginAccount: null, //	登录账号	string	
					roleId: null, //	角色id	array<number>	
					username: null, //用户名
				},
				togglePage: false, //是否显示分页
				toggleStDialog: false,// 弹窗，
				dialogTitle: '新增角色2',
				
			}
		},
		created() {

		},
		methods: {
			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},

			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},
			shortAddressChange({value, location}) {
				this.editData.longitude = location.lng
				this.editData.latitude = location.lat
				this.editData.shortAddress = value
			},

			getNearAddress(e) {
				if (this.selectedOptions.length == 0) {
					return this.$toast.stMessage('请先选择省市区', 'warning')
				}
				this.loading = true;
				geoplace2(this, e, CodeToText[this.selectedOptions[1]]).then(res => {
					console.log('结果', res)
					if (res.message === 'query ok') {
						this.loading = false
						this.nearAddressArr = res.data
					} else {
						this.loading = false
						this.$toast.stMessage(res.message)
					}
				})
			},
			
			deleteUser() {
				if (this.selectedList.length == 0) {
					return this.$toast.stMessage('请选择需要删除的用户', false)
				}

				if (this.selectedList.length != 1) {
					return this.$toast.stMessage('请勿选择多个用户', false)
				}

				this.$confirm('是否确认删除用户?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$server.system.deleteUser(this.selectedList[0].id, (res) => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.searchList()
					})
				})
			},

			addUser() {
				this.editData = {
					genre: 'SYSTEM'
				}
				this.dialogTitle = '新增账号'
				this.toggleStDialog = true
			},

			resetEditData() {
				this.editData = {
					genre: 'SYSTEM'
				}
				this.selectedOptions = []
			},

			handleChange(value) {
				console.log(value)
				// 省市区选择
				const [provinceName, cityName, areaName] = [CodeToText[value[0]], CodeToText[value[1]], CodeToText[value[2]]]
				this.editData.provinceName = provinceName
				this.editData.cityName = cityName
				this.editData.areaName = areaName
				this.editData.provinceCode = value[0]
				this.editData.cityCode = value[1]
				this.editData.areaCode = value[2]
			},

			selectionChange(val) {
				this.selectedList = val;
				console.log(this.selectedList)
			},

			searchList(flag) {
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if(flag) pages.current = 1;
				let orderForm = this.orderForm;
				Object.assign(orderForm, pages)
				this.loading=true;
				this.getData(orderForm)
			},
			
			getRoleList() {
				this.$server.role.getRole({
					current: 1,
					size: 999
				}, res => {
					console.log(res)
					this.roleTypeList = res.data.records
				})
			},

			getData(data) {
				this.$server.system.userPage(data, (res) => {
					this.loading=false;
					if (res.code == 0) {
						this.dataList = res.data.records;

						this.pageConfig.total = res.data.total;
						this.pageConfig.currentPage = res.data.current;
						if (res.data.total > 0) {
							this.togglePage = true;
						}
					}
				})
			},

			getRoldId(id) {
				return new Promise((resolve, reject) => {
					this.$server.role.getUser(id, res => {
						const roleId = res.data.roleList.map(item => {
							return item.id
						})
						resolve(roleId)
					})
				})
			},

			async editUser(row) {
				this.dialogTitle = '编辑账号'
				const roleId = await this.getRoldId(row.id)
				this.$nextTick(() => {
					this.editData = JSON.parse(JSON.stringify(row))
					this.$set(this.editData,"roleId", roleId)
					this.selectedOptions = [row.provinceCode, row.cityCode, row.areaCode]
					this.toggleStDialog = true;
				})
				
			},

			checkData() {
				for (let i in this.normalCheck) {
					if (!this.editData[i]) {
						this.$toast.stMessage(this.normalCheck[i], false)
						return false
					}
				}

				if (this.editData.genre == 'FRANCHISE') {
					for (let i in this.franshiseCheck) {
						if (!this.editData[i]) {
							this.$toast.stMessage(this.franshiseCheck[i], false)
							return false
						}
					}
				}

				return true
			},

			async saveDialogForm() {
				
				if (!this.checkData()) return
				let data = Object.assign({}, this.editData);
				// 测试
				// let data = {
				// 	name:"省钱运测试物流",
				// 	state:1,
				// 	contactPhone:"15302394457",
				// 	contactSubject:"cyx",
				// 	provinceCode: "440000",
				// 	provinceName:"广东省",
				// 	cityCode: "442000",
				// 	cityName:"中山市",
				// 	areaCode:"442013",
				// 	areaName:"古镇镇",
				// 	shortAddress:"华艺广场",
				// 	fullAddress:"广东省中山市古镇中兴大道南1号",
				// 	latitude:"22.602723",
				// 	longitude:"113.189382",
				// 	logisticsUser:{
				// 		username:"15302394457",
				// 		password:"e10adc3949ba59abbe56e057f20f883e"
				// 	},
				// 	"logisticsSite":{
				// 	}

				// }
				let sendMethod = 'editUser'
			
				if (!this.editData.id) {
					sendMethod = 'addUser'
				}
				//保存设置
				this.$server.system[sendMethod](data, res => {
					if (res.code == 0) {
						this.$toast.stMessage(`设置成功`, true)
						this.toggleStDialog = false;
						this.searchList()
					} else {
						this.$toast.stMessage(res.message, false)
					}
				})
			},
			closeDialogForm(){
				this.toggleStDialog=false;
			},
			changeStatus(row) {
				this.$server.system.switchUserState(row.id, res => {
					if (res.code == 0) {
						this.$toast.stMessage(`设置成功`, true)
					} else {
						this.$toast.stMessage(res.message, false)
						this.resetEditData()
						this.searchList()
					}
				})
			},
		},
		mounted() {
			this.getRoleList()
		}
	}

</script>


<style scoped>
	.st-main-content .el-input__icon {
		line-height: normal;
	}
	
	.st-main-content .ssq {
		width: 250px;
		height: 31px;
		line-height: normal;
	}
	
	.st-main-content .ssq .el-input__inner {
		width: 250px;
	}
	.require-desc {
		color: red;
	}

	.st-dialog-form {
		display: flex;
		justify-content: flex-start;
		width: 720px;
	}

	.st-dialog-form li {
		margin-right: 20px;
	}

	.query-setting-box-left {
		flex-grow: 0;
	}

	.account-manage {
		width: 100%;
		height: auto;
	}

	.setRole {
		display: inline-block;
		width: 95px;
		height: 32px;
		line-height: 32px;
		color: #32BB57;
		cursor: pointer;
		margin: 0;

	}

	.st-order-btns {
		display: flex;
		justify-content: space-around;
	}

	.st-order-btns span {
		width: 80px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		color: #fff;
		border-radius: 2px;
		cursor: pointer;
		margin-left: 8px;
	}

	.stStgz {
		background-color: #FF5B3E;
	}

	.stMbgc {
		background-color: #32BB57;
	}

	/* 弹窗内 */
	/*  */
	.st-dialog-content {
		min-height: 200px;
		padding: 0 32px;
	}

	.st-dialog-form {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.st-dialog-form li {
		width: 156px;
		padding: 13px 0;
	}

	.st-dialog-form li:nth-child(even) {
		float: right;
	}

	.st-dialog-form li:nth-child(odd) {
		float: left;
	}

	.st-dialog-form .st-dialog-item-title {
		height: 20px;
		line-height: 20px;
	}

	.st-dialog-form .st-dialog-item-title i {
		color: #FF5B3E;
	}

	.st-dialog-form .st-dialog-item-input input {
		width: 156px;
		height: 30px;
		text-indent: 8px;
		border-radius: 2px;
		border: 1px solid #DCDCDC;
		box-sizing: border-box;
	}

	.setConfig {
		cursor: pointer;
	}

	/* end */
</style>